import React from "react";

const ChangelogHeroSection = () => {
  return (
    <div className="text-protocol-base font-sans">
      <div className="mt-24">
        <div className="flex flex-col items-center space-y-6">
          <span className="text-base leading-5">Home / Change Log</span>
          <div
            className="lg:w-11/12 xxl:w-full font-extrabold
           text-xxxl leading-8 lg:text-[44px] lg:leading-[44px] md:text-6xl xxl:text-[64px] 
           text-center xxl:leading-[80px]"
          >
            <p>STAY UP-TO-DATE WITH SPHERON&apos;S</p>
            <p>LATEST INNOVATIONS</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangelogHeroSection;
